import { render } from "./CardBusinessVas.vue?vue&type=template&id=4e6050e4&scoped=true"
import script from "./CardBusinessVas.vue?vue&type=script&lang=js"
export * from "./CardBusinessVas.vue?vue&type=script&lang=js"

import "./CardBusinessVas.vue?vue&type=style&index=0&id=4e6050e4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6050e4"]])

export default __exports__